import {
  Accessibility,
  ArrowRight,
  ArrowUpDown,
  ArrowUpRight,
  BedDouble,
  Building2,
  Bus,
  Calendar,
  Car,
  Check,
  ChevronDown,
  ChevronLeft,
  ChevronRight,
  ChevronUp,
  Church,
  Clock,
  Crosshair,
  Dumbbell,
  Footprints,
  Globe,
  GraduationCap,
  HeartPulse,
  History,
  Info,
  Landmark,
  Layers,
  LocateFixed,
  MapPin,
  Milestone,
  Minus,
  Phone,
  Plus,
  RotateCcw,
  Search,
  Share2,
  ShoppingBag,
  Signpost,
  TrainFront,
  Trees,
  TriangleAlert,
  Utensils,
  Wrench,
  X,
} from 'lucide';

export type IconNode = readonly (readonly [
  string,
  Readonly<Record<string, string | number | undefined>>,
])[];

export const ICONS = {
  accessibility: Accessibility,
  arrowRight: ArrowRight,
  arrowUpRight: ArrowUpRight,
  bed: BedDouble,
  building: Building2,
  bus: Bus,
  calendar: Calendar,
  car: Car,
  check: Check,
  chevronDown: ChevronDown,
  chevronLeft: ChevronLeft,
  chevronRight: ChevronRight,
  chevronUp: ChevronUp,
  church: Church,
  clock: Clock,
  close: X,
  crosshair: Crosshair,
  dumbbell: Dumbbell,
  footprints: Footprints,
  globe: Globe,
  graduation: GraduationCap,
  health: HeartPulse,
  history: History,
  info: Info,
  landmark: Landmark,
  layers: Layers,
  locate: LocateFixed,
  minus: Minus,
  phone: Phone,
  pin: MapPin,
  plus: Plus,
  locality: Milestone,
  reset: RotateCcw,
  search: Search,
  share: Share2,
  shopping: ShoppingBag,
  street: Signpost,
  swap: ArrowUpDown,
  train: TrainFront,
  trees: Trees,
  utensils: Utensils,
  warning: TriangleAlert,
  wrench: Wrench,
} satisfies Record<string, IconNode>;

export type IconName = keyof typeof ICONS;

export function iconBody(name: IconName): string {
  return ICONS[name]
    .map(
      ([tag, attributes]) =>
        `<${tag} ${Object.entries(attributes)
          .filter((entry): entry is [string, string | number] => entry[1] !== undefined)
          .map(([key, value]) => `${key}="${String(value)}"`)
          .join(' ')}/>`,
    )
    .join('');
}
